<template>
  <div class="w1200 hspe">
    <div class="titlebox">
      <div class="topbox">
        <span class="titlename">热门专题</span><a class="seeMore" href="/specialtopic" target="_blank">查看更多</a>
      </div>
    </div>
    <div v-if="list.length>0" class="Box">
      <a v-for="item in list" :key="item.SPECIAL_ID" class="imgbox" :href="'/specialTopicDetail?contentId='+item.SPECIAL_ID" target="_blank">
        <div class="shadow" />
        <img :src="item.SPECIAL_COVER" alt="">
        <p class="specialname">
          {{ item.SPECIAL_NAME }}
        </p>
      </a>
    </div>
    <div v-else class="Box noBox">
      暂无内容
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  methods: {
    seemore: function() {
      this.$router.push({ path: '/specialtopic' })
    },
    goDetial: function(id) {
      this.$router.push({ path: '/specialTopicDetail', query: { 'contentId': id }})
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .titlebox .topbox{
    height: 40px;
    line-height: 40px;
    background-color: #fff;
  }
  .hspe{
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #FAFAFA;
  }
    .titlebox{
        font-size: 0;
    }
    .titlename{
        display: inline-block;
        width: 80px;
        height: 20px;
        line-height: 20px;
        border-left: 2px solid #ed4040;
        padding-left: 10px;
        font-size: 16px;
      margin-left: 20px;
      font-weight: 600;
    }
    .seeMore{
        display: inline-block;
        height: 20px;
        font-size: 15px;
        float: right;
        margin-right:20px;
        color: #b2b2b2;
        cursor: pointer;
        &:hover{
            color: #ed4040;
        }
    }
    .Box{
        width:100%;
        height: 120px;
        padding:20px 0;
        font-size: 0;
        .imgbox{
            width: 275px;
            height: 120px;
            display: inline-block;
            margin-right: 33px;
            position: relative;
            cursor: pointer;
          font-size: 0;
          img{
            width: 275px;
            height: 120px;
          }
            .shadow{
                width: 275px;
                height: 120px;
                position: absolute;
                background-color:rgba(0,0,0,.3);
                z-index: 2;
              transition: 0.3s;
                &:hover{
                    background-color:rgba(0,0,0,.0);
                }
            }
            .specialname{
                position: absolute;
                 top: 48px;
                font-size: 18px;
                color: #ffffff;
                width: 100%;
                text-align: center;
                font-weight: 500;
              overflow: hidden;
              z-index: 3;
            }
        }
      .imgbox:nth-child(4n){
        margin-right: 0;
      }
    }
  .noBox{
    font-size: 20px!important;
    color: #ccc;
    text-align: center;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .hspe{
      padding-bottom: 0;
    }
    .Box{
      height: auto;
      padding: 0 20px;
      padding-bottom: 20px;
      width: auto;
      .imgbox{
        width: 100%;
        display: block;
        padding-bottom: 20px;
       .specialname{
         width: 100%;
       }
        img{
          width: 100%;
        }
      }
      .shadow{
        display: none!important;
      }
    }
  }
</style>
